import React from 'react';
import './EventsCarousel.css';
import eventsListImg from '../../assets/events_list.png';
import fireflyBg from '../../assets/firefly-bg.png';

const EventsCarousel = ({ onImageClick }) => {
    return (
        <div className="events-carousel-wrapper">
            <div className="ec-gradient-overlay"></div>

            <div className="ec-slider">
                {/* Background Slide */}
                <div className="ec-slide-bg">
                    <img src={fireflyBg} alt="" className="ec-slide-bg-img" />
                    <div className="ec-slide-bg-overlay"></div>
                </div>

                {/* Single Main Card */}
                <div className="ec-card-group single-card-layout">
                    <div 
                        className="ec-card ec-main-img" 
                        onClick={onImageClick}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="h-full w-full">
                            <img src={eventsListImg} alt="Event List" className="object-cover" style={{ willChange: 'transform' }} />
                            <div className="ec-card-overlay"></div>
                        </div>
                    </div>
                </div>

                {/* Text and Actions */}
                <div className="ec-copy">
                    <div className="ec-title-container">
                        <h1 className="ec-title">
                            <span className="ec-title-main">EVENTS</span>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventsCarousel;
